import {IDataEntityResponse, IToggleRequest, IDataEntity } from "../models";
import { Actions } from '../actions';
import { safe } from "../utils";
import { GET_FUNDS_START, GET_FUNDS_END, TOGGLE_FUND, TOGGLE_SHARE_CLASS_PERFORMANCE, TOGGLE_SHARE_CLASS, TOGGLE_ALL_FUNDS, INFINITE_SCROLL_END } from "../actions";

function toggleShareClassProperty(property, state, action) {
	let { shareClass, mustExpand } = action.payload as any as IToggleRequest;
	let matchingFunds = state.values.filter(i => i.clientCode === shareClass.properties['fund_key']);

	let stateValues = safe(() => {
		let matchingShareClasses = matchingFunds.reduce((existing, current) => {
			let shareClasses = current.shareClasses.filter(i => i.clientCode === shareClass.clientCode);
			if (shareClasses && shareClasses.length > 0) {
				existing.shareClass = shareClasses[0];
				existing.fund = current;
			}
			return existing;
		}, { fund: null, shareClass: null });
		return matchingShareClasses;
	}, null);

	let fundIndex = state.values.indexOf(stateValues.fund);
	let shareClassIndex = stateValues.fund.shareClasses.indexOf(stateValues.shareClass);
	let propertyAssignmentObj = {};
	propertyAssignmentObj[property] = mustExpand;
	stateValues.shareClass = Object.assign({}, stateValues.shareClass, propertyAssignmentObj);
	stateValues.fund.shareClasses = [...stateValues.fund.shareClasses.slice(0, shareClassIndex), stateValues.shareClass, ...stateValues.fund.shareClasses.slice(shareClassIndex + 1)];
	let newValues = [...state.values.slice(0, fundIndex), stateValues.fund, ...state.values.slice(fundIndex + 1)];
	return Object.assign({}, state, { values: newValues });
}

export function fundsReducer(state: IDataEntityResponse = { isDefaultState: true, total: 0, limit: 0, values: [] }, action: Actions) {
	switch (action.type) {
		case GET_FUNDS_END:
			return action["payload"] || {};
		case INFINITE_SCROLL_END:
			let currentFundObj = state;
			if (currentFundObj && currentFundObj.values && action.payload && action.payload.values) {
				let values = [];
				let newFundsByClientCode : { [key: string]: IDataEntity } = action.payload.values.reduce((acc, fund) => {
					acc[fund.clientCode] = fund;
					return acc;
				}, {});
				for (let fund of currentFundObj.values) {
					let newFund = newFundsByClientCode[fund.clientCode];
					if (newFund && newFund.shareClasses && newFund.shareClasses.length > 0) {
						if (!fund.shareClasses) {
							fund.shareClasses = [];
						}
						fund.shareClasses.push(...newFund.shareClasses);
					}
					values.push(fund);
				}

				let response = Object.assign({}, state, { values });
				return response;
			}
			return state;
		case TOGGLE_SHARE_CLASS_PERFORMANCE:
			return toggleShareClassProperty('showPerformance', state, action);
		case TOGGLE_SHARE_CLASS:
			return toggleShareClassProperty('collapsed', state, action);
		case TOGGLE_FUND:
			{
				let { fund, mustExpand } = action["payload"] as any as IToggleRequest;

				let stateFund = safe(() => state.values.filter(i => i === fund)[0]);
				let index = state.values.indexOf(stateFund);
				fund = Object.assign({}, fund, { collapsed: mustExpand });

				let newValues = [...state.values.slice(0, index), fund, ...state.values.slice(index + 1)];

				return Object.assign({}, state, { values: newValues });
			}
		case TOGGLE_ALL_FUNDS:
			{
				let { mustExpand } = action["payload"] as any as IToggleRequest;
				if (state && state.values) {
					let newValues = state.values.map(fund => {
						fund.shareClasses = fund.shareClasses.map(shareClass => Object.assign({}, shareClass, { collapsed: !mustExpand }));
						return Object.assign({}, fund, { collapsed: !mustExpand });
					});
					return Object.assign({}, state, { values: newValues });
				}
				return state;

			}
		default: return state;
	}
}


// WEBPACK FOOTER //
// ./src/client/reducers/funds.ts